import { useEffect } from 'react';

import { useConsentStatus } from '@/ampli';
import { initGoogleAds, trackGoogleAdsSignup } from '@/utils/google-ads';
import {
  initLinkedInInsight,
  trackLinkedInSignup,
} from '@/utils/linkedin-insight';
import { initMetaPixel, trackMetaPixelSignup } from '@/utils/meta-pixel';
import { consumePendingSignupConversion } from '@/utils/signup-conversion';

/**
 * Fires ad sign-up conversions on the page after the post-verification reload,
 * once the user has accepted cookies. The tags are initialised here too because
 * this effect can run before the sibling tag components' effects.
 */
const SignupConversionTag = () => {
  const isOptedIn = useConsentStatus() === 'optedIn';

  useEffect(() => {
    if (!isOptedIn) {
      return;
    }

    const userId = consumePendingSignupConversion();
    if (userId == null) {
      return;
    }

    initGoogleAds();
    initLinkedInInsight();
    initMetaPixel();
    trackGoogleAdsSignup(userId);
    trackLinkedInSignup();
    trackMetaPixelSignup();
  }, [isOptedIn]);

  return null;
};

export default SignupConversionTag;
